// Plugins
import { registerPlugins } from '@/plugins'

// Components
import App from './App.vue'
import { sentryInit } from '@/plugins/sentry'
import { createPinia } from 'pinia'
import router from './router'

import '@/assets/css/main.css'

// Composables
import { createApp } from 'vue'

const app = createApp(App)
sentryInit(app, router)
app.use(createPinia())
app.use(router)

registerPlugins(app)

app.mount('#app')
